import { BaseController } from "../../common/base/controller";
import { startStateName } from "../start/start.state";
import _ from "lodash";

export class ConsorsUserInitController extends BaseController {
	constructor(controllerService, consorsUserInitService) {
		"ngInject";
		super({
			controllerService,
			consorsUserInitService,
		});
	}

	storeUser(users) {
		users.forEach((user) => {
			if (!user.dob) return;
			const { year, day, month } = user.dob;
			user.birthday = new Date(year, month - 1, day, 12).toISOString();
		});
		this.appCache.set("newOwners", users);
	}

	storeAccountNumber(portfolioId) {
		this.appCache.set("newBank", {
			portfolioId,
			orderOfAccountFields: {
				accounts: [{ number: portfolioId, type: "portfolioId" }],
			},
		});
	}

	$onInit() {
		const { userId, exp, sig } = this.$stateParams;
		this.error = null;

		this.consorsUserInitService
			.getUser(userId, sig, exp)
			.then((resp) => {
				const { targetSecuritiesAccount } = _.first(resp.users);
				this.storeUser(resp.users);
				this.storeAccountNumber(targetSecuritiesAccount);

				this.go(startStateName, {
					preserveFields: ["newOwners", "newBank"],
				});
			})
			.catch((res) => {
				this.error = `app.consorsUserInit.error.${res.status}`;
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/consorsUserInit/consorsUserInit.controller.js